import axios from '../../axios-config'
export const getAllWhatNew = () => {
  return axios.get('/score/api/v1/whats/new')
}
